import { useGamesStore } from '../../store';
import { useProvider } from '../useProvider';

export const useProviderByServiceId = (serviceId: number) => {
  const providerId = useGamesStore(
    (store) => store.providers.serviceIdToProviderId[serviceId]
  );
  return useProvider(providerId);
};
